import React from 'react';
import { SideNav } from '@ver-uds/uswds-react';
import { NavLink } from 'react-router-dom';
import Feature from '../../../../constants/Feature';

export type SideNavItems = {
  href: string;
  text: string;
  feature: Feature;
};
interface EveSideNavProps {
  currentFeature: Feature;
  sideNavItems: SideNavItems[];
}

const SideNavLink = ({ children, href = '/' }: React.ComponentPropsWithoutRef<typeof SideNav.Link>): JSX.Element => (
  <NavLink to={href} activeClassName="usa-current">
    {children}
  </NavLink>
);

const EveSideNav = ({ currentFeature, sideNavItems }: EveSideNavProps): JSX.Element => (
  <>
    {sideNavItems.length > 0 ? (
      <SideNav data-testid="side-nav">
        {sideNavItems.map(({ href, text, feature }) => (
          <SideNav.Item
            key={href}
            href={href}
            text={text}
            current={currentFeature === feature}
            linkComponent={SideNavLink}
          />
        ))}
      </SideNav>
    ) : null}
  </>
);

export default EveSideNav;
